import styled from "styled-components";

export const CustomAccordianWrapper = styled.div`
  .accordionWrap {
    .accordionItem {
      border-radius: 25px;
      overflow: hidden;
      transition: all 0.4s ease-in-out;
      @media (max-width: 1199px) {
        border-radius: 15px;
      }
      @media (max-width: 899px) {
        border-radius: 10px;
      }
      &:not(:last-child) {
        margin-bottom: 30px;
        @media (max-width: 1199px) {
          margin-bottom: 20px;
        }
        @media (max-width: 899px) {
          margin-bottom: 15px;
        }
      }
      &:first-child {
        border-top: none;
      }

      .accordionHeader {
        padding: 17px 45px 17px 68px;
        background: rgb(31, 31, 31);
        border-radius: 25px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media (max-width: 1199px) {
          padding: 17px 20px;
          border-radius: 15px;
        }
        @media (max-width: 899px) {
          padding: 15px;
          border-radius: 10px;
        }
        span {
          font-weight: 700;
          font-size: 32px;
          color: rgb(255, 255, 255);
          @media (max-width: 1199px) {
            font-size: 26px;
          }
          @media (max-width: 899px) {
            font-size: 18px;
          }
        }
        .arrow {
          line-height: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.4s ease-in-out;
          svg {
            @media (max-width: 899px) {
              width: 17px;
              height: 17px;
            }
          }
        }

        .rotate {
          transform: rotate(360deg);
        }
      }

      .accordionBody {
        max-height: 0;
        overflow: hidden;
        transition: 0.3s ease-in-out;

        .accordionContent {
          padding: 17px 30px;
          background: rgb(255, 255, 255);
        }
      }

      &.expanded {
        box-shadow: 0px 8px 13.5px 5px rgba(0, 0, 0, 0.25);
        .accordionHeader {
          border-radius: 25px 25px 0 0;
          @media (max-width: 1199px) {
            border-radius: 15px 15px 0px 0px;
          }
          @media (max-width: 899px) {
            border-radius: 10px 10px 0 0;
          }
        }
        .accordionBody {
          max-height: inherit;
        }
      }
    }
  }
`;
